import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { GenerateStatusDialog } from "./dialog/generate/generate-status-dialog.component";
import { AssignmentPromptDialog } from "./dialog/prompt/assignment-prompt-dialog.component";
import { WarnAboutMlChangesDialog } from "./dialog/warning/warn-about-ml-changes-dialog.component";
import { MlResult } from "./ml-result.model";

@Component({
    selector: "ml-assignment-component",
    templateUrl: "./ml-assignment.component.html",
    styleUrls: ["./ml-assignment.component.css"],
})
export class MlAssignmentComponent implements OnInit {
    @Input() slideshow;

    constructor(public dialog: MatDialog) {}

    ngOnInit(): void {}

    GenerateMlArticle() {
        if (this.checkForSlideContent()) {
            let dialogRef = this.dialog.open(WarnAboutMlChangesDialog, {});

            dialogRef.afterClosed().subscribe((okayToOverwrite) => {
                console.debug(okayToOverwrite);
                if (okayToOverwrite) {
                    this.handleMlPrompt();
                }
            });
        } else {
            this.handleMlPrompt();
        }
    }

    handleMlPrompt() {
        let dialogRef = this.dialog.open(AssignmentPromptDialog, {});

        dialogRef.afterClosed().subscribe((prompt) => {
            console.debug(prompt);
            if (prompt) {
                this.handleMlGenerate(prompt);
            }
        });
    }

    handleMlGenerate(prompt: string) {
        let dialogRef = this.dialog.open(GenerateStatusDialog, {
            data: {
                prompt: prompt,
                slideshow: this.slideshow,
            },
            disableClose: true,
            width: "500px",
            height: "80vh",
        });

        dialogRef.afterClosed().subscribe((result: MlResult) => {
            console.debug(result);
            if (!result.status.retry && !result.status.cancel) {
                this.updateSlideshow(result);
            } else if (result.status.retry) {
                this.handleMlGenerate(prompt);
            }
        });
    }

    updateSlideshow(newContent: MlResult) {
        let slideIntroOffset = 0;
        this.slideshow.assignment.mlPrompt = newContent.prompt;

        this.slideshow.slides[0].headers = [newContent.title];
        this.slideshow.slides[0].title = newContent.title;

        this.slideshow.assignment.articleTitle = newContent.title;
        if (newContent.intro) {
            this.slideshow.slides[0].content = [];
            newContent.intro.forEach((paragraph) => {
                this.slideshow.slides[0].content.push({ text: paragraph });
            });
            slideIntroOffset = 1;
        }

        newContent.slides.forEach((slide, index) => {
            if (!this.slideshow.slides[index + slideIntroOffset]) {
                this.slideshow.createSlide();
            }
            this.slideshow.slides[index + slideIntroOffset].headers = [
                slide.header,
            ];
            this.slideshow.slides[index + slideIntroOffset].title =
                slide.header;

            this.slideshow.slides[index + slideIntroOffset].content = [];
            slide.content.forEach((paragraph) => {
                this.slideshow.slides[index + slideIntroOffset].content.push({
                    text: paragraph,
                });
            });

            this.slideshow.slides[index + slideIntroOffset].mlTopic =
                slide.topic;

            this.updateMetaDetails(
                this.slideshow.slides[index + slideIntroOffset],
                slide.content
            );
        });

        if (newContent.intro && (this.slideshow.assignment.metaTitle == '' || this.slideshow.assignment.metaTitle == '')) {
            this.updateMetaDetails(this.slideshow.slides[0], newContent.intro);
            this.slideshow.assignment.metaTitle = this.slideshow.slides[0].metaTitle;
            this.slideshow.assignment.metaDescription = this.slideshow.slides[0].metaDescription;
        }
    }

    updateMetaDetails(slide, content) {
        this.slideshow.titleChange(slide);
        this.slideshow.updateMetaDescription(slide, content.join("\n"));
    }

    checkForSlideContent() {
        let slideContent = this.slideshow.slides.find((slide) => {
            const innerContent = slide.content.find(
                (content) =>
                    (content.title && content.title.length > 0) ||
                    (content.text && content.text.length > 0)
            );
            const innerHeader = slide.headers.find(
                (header) => header.length > 0
            );
            return (
                innerContent ||
                innerHeader ||
                slide.images.length > 0 ||
                slide.title.length > 0
            );
        });
        if (slideContent) {
            return true;
        } else {
            return false;
        }
    }
}
